export default __webpack_public_path__ + "static/media/Messages.a6fc6734.svg";